import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import { Card, CardBody, Col } from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import { Spinner } from "reactstrap";

const apiClient = new APIClient();

const formatNumber = (val) => {
  if (val == null || Number.isNaN(Number(val))) return 0;
  return Number(val);
};

const WIDGET_CONFIG = [
  {
    key: "availableStockQuantity",
    label: "Available Stock (Units)",
    icon: "ri-box-3-line",
    suffix: "",
    decimals: 0,
    badge: "ri-archive-line",
  },
  {
    key: "availableStockValue",
    label: "Stock Value (Money in Stock)",
    icon: "ri-wallet-line",
    prefix: "₹",
    decimals: 2,
    badge: "ri-wallet-line",
  },
  {
    key: "containerCount",
    label: "Containers",
    icon: "ri-ship-line",
    suffix: "",
    decimals: 0,
    badge: "ri-ship-2-line",
  },
  {
    key: "totalEarnings",
    label: "Total Earnings",
    icon: "ri-arrow-up-circle-line",
    prefix: "₹",
    decimals: 2,
    badge: "ri-arrow-up-line",
  },
  {
    key: "totalSpend",
    label: "Total Spend",
    icon: "ri-arrow-down-circle-line",
    prefix: "₹",
    decimals: 2,
    badge: "ri-arrow-down-line",
  },
];

const SummaryWidgets = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get("/dashboard/summary");
        const raw = response?.data ?? response;
        const summaryObj = Array.isArray(raw) ? raw[0] : raw;
        setSummary(summaryObj && typeof summaryObj === "object" ? summaryObj : null);
      } catch (err) {
        setError(err?.message || "Failed to load summary");
        setSummary(null);
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, []);

  if (loading) {
    return (
      <Col xs={12} className="text-center py-5">
        <Spinner color="primary" />
        <p className="text-muted mt-2 mb-0">Loading dashboard...</p>
      </Col>
    );
  }

  if (error) {
    return (
      <Col xs={12}>
        <div className="alert alert-danger mb-0">{error}</div>
      </Col>
    );
  }

  return (
    <React.Fragment>
      {WIDGET_CONFIG.map((item) => (
        <Col key={item.key}>
          <Card className="card-animate bg-light border-0 shadow-sm">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-bold text-muted text-truncate mb-0">
                    {item.label}
                  </p>
                </div>
                <div className="flex-shrink-0">
                  {item.badge ? <i className={"fs-13 align-middle text-muted " + item.badge}></i> : null}
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-22 fw-bold ff-secondary mb-0 text-dark">
                    <span className="counter-value">
                      <CountUp
                        start={0}
                        prefix={item.prefix || ""}
                        suffix={item.suffix || ""}
                        separator=","
                        end={formatNumber(summary?.[item.key])}
                        decimals={item.decimals}
                        duration={1.5}
                      />
                    </span>
                  </h4>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title rounded fs-3 bg-primary bg-opacity-10">
                    <i className={`${item.icon} text-primary`}></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </React.Fragment>
  );
};

export default SummaryWidgets;
